module.exports = __webpack_public_path__ + "img/qph3.2c99ec87.jpg";